module.exports = __webpack_public_path__ + "img/erudio_certificate_enterprise.dea901d4.svg";